<template>
  <v-container
    tag="section"
  >
    <base-material-card
      color="coolrunner"
      icon="mdi-account"
      inline
      class="px-5 py-3"
    >
      <template v-slot:after-heading>
        <div class="text-h2 font-weight-light">
          {{ $t('customers') }}
        </div>
      </template>

      <v-row class="mx-0">
        <v-col cols="6">
          <filter-main
            :filter-options="filterOptions"
            :filter-actions="filterActions"
            :filter="filter"
            @set-filter="setFilter"
          />
        </v-col>
        <v-text-field
          v-model="search"
          append-icon="mdi-magnify"
          class="ml-auto"
          :label="$t('search')"
          hide-details
          single-line
          style="max-width: 250px;"
          @blur="getDataFromApi"
          @keydown.enter="getDataFromApi"
        />
      </v-row>
      <v-divider class="my-3" />

      <v-data-table
        :headers="headers"
        :items="items"
        :options.sync="options"
        :server-items-length="totalItems"
        :loading="loading"
        :footer-props="{
          itemsPerPageOptions: [10, 20, 50, 100]
        }"
        dense
        class="elevation-1"
      >
        <template v-slot:body.prepend>
          <filter-row
            :filter-options="filterOptions"
            :headers="headers"
            :filter="filter"
            @set-filter="setFilter"
          />
        </template>
        <template v-slot:item.business="{ item }">
          <v-icon
            v-if="item.business"
            color="green"
          >
            check
          </v-icon>
          <v-icon
            v-else
            color="red"
          >
            not_interested
          </v-icon>
        </template>
        <template v-slot:item.created_at="{item}">
          {{ convertUTCToLocal(item.created_at) }}
        </template>

        <template v-slot:item.action="{ item }">
          <v-btn
            icon
            x-small
            :to="editItem(item)"
          >
            <v-icon
              medium
              color="green"
              class="mr-2"
            >
              mdi-pencil
            </v-icon>
          </v-btn>
        </template>
      </v-data-table>
    </base-material-card>
  </v-container>
</template>
<script>
  import List from '@/mixins/List'

  export default {
    mixins: [List],

    data () {
      return {
        endpoint: 'customers',
        headers: [
          {
            sortable: false,
            text: this.$t('id'),
            value: 'id',
          },
          {
            text: this.$t('name'),
            value: 'name',
          },
          {
            sortable: false,
            text: this.$t('company'),
            value: 'company_name',
          },
          {
            sortable: false,
            text: this.$t('business_customer'),
            value: 'business',
          },
          {
            sortable: true,
            text: this.$t('email'),
            value: 'email',
          },
          {
            sortable: true,
            text: this.$t('phone'),
            value: 'billing_address.phone',
          },
          {
            sortable: false,
            text: this.$t('created'),
            value: 'created_at',
          },
          { text: this.$t('actions'), value: 'action', align: 'right', sortable: false },

        ],
        filterOptions: {
          id: {
            label: this.$t('customer_id'),
            type: 'range',
            filter: { from: '', to: '' },
          },
          name: {
            label: this.$t('name'),
            type: 'free',
            filter: '',
          },
          company_name: {
            label: this.$t('company'),
            type: 'free',
            filter: '',
          },
          business: {
            label: this.$t('business_customer'),
            type: 'single',
            options: [
              { slug: '1', label: this.$t('yes') },
              { slug: '0', label: this.$t('no') },
            ],
            filter: [],
          },
          email: {
            label: this.$t('email'),
            type: 'free',
            filter: '',
          },
          'billing_address.phone': {
            label: this.$t('phone'),
            type: 'free',
            filter: '',
          },
          created_at: {
            label: 'Oprettelsesdato',
            type: 'date-range',
            filter: {},
          },
        },
      }
    },
    methods: {
      editItem: function (item) {
        if (item && item.id) { return `/customers/${item.id}` }
        return '/customers/null'
      },
    },
  }
</script>
